import { render } from "./BodyAgroLarge.vue?vue&type=template&id=11054758&scoped=true"
import script from "./BodyAgroLarge.vue?vue&type=script&lang=js"
export * from "./BodyAgroLarge.vue?vue&type=script&lang=js"

import "./BodyAgroLarge.vue?vue&type=style&index=0&id=11054758&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11054758"]])

export default __exports__